import type { FC } from 'react';

import { LevelBadge } from '../code-chip/level-badge';
import type { CodePeekEntry } from './use-code-peek';
import { useCodePeek } from './use-code-peek';

interface BreadcrumbStripProps {
	history: CodePeekEntry[];
}

export const BreadcrumbStrip: FC<BreadcrumbStripProps> = ({ history }) => {
	const peek = useCodePeek();
	if (!peek || history.length <= 1) return null;
	return (
		<nav
			className='code-peek__breadcrumb'
			aria-label='Peek history'
		>
			{history.map((entry, idx) => {
				const isLast = idx === history.length - 1;
				return (
					<span
						key={`${entry.level}-${entry.code}-${idx}`}
						className='code-peek__breadcrumb-item'
					>
						{isLast ? (
							<span className='code-peek__breadcrumb-current'>
								<LevelBadge level={entry.level} />
								<span>{entry.code}</span>
							</span>
						) : (
							<button
								type='button'
								className='code-peek__breadcrumb-link'
								onClick={() => peek.goToHistory(idx)}
							>
								<LevelBadge level={entry.level} />
								<span>{entry.code}</span>
							</button>
						)}
						{!isLast && (
							<span
								className='code-peek__breadcrumb-sep'
								aria-hidden='true'
							>
								›
							</span>
						)}
					</span>
				);
			})}
		</nav>
	);
};
